import PinkPillButton from './PinkPillButton'
export default PinkPillButton;